import { createBlankSurveyFlow, createSampleJobApi } from 'src/api/yembo/job';
import { CompanyDefaultSurveyType } from 'src/types';
import { ContactJobState, CreateContactFormData } from '..';

type Props = {
  data: CreateContactFormData & { job: ContactJobState };
  type: Exclude<CompanyDefaultSurveyType, 'self_survey'>;
};

export const createSurveyFlow = async ({ data, type }: Props) => {
  switch (type) {
    case 'manual_survey':
      return (await createBlankSurveyFlow({
        data: data as unknown as Parameters<typeof createBlankSurveyFlow>[0]['data'],
      })) as { job: { key: string } };

    case 'sample_ai_self_survey':
      return (await createSampleJobApi({
        data: {
          surveyType: 'ai_self_survey',
          companyKey: data.company.key,
          employeeKey: data.employee?.key,
          locale: data.job.locale,
        },
      })) as {
        job: { key: string };
      };

    default:
      throw new Error('survey type not exist in api call');
  }
};
